import _ from 'lodash'

export default ({ group, groupKey }) => _.get(group, `${groupKey}.id`)
